.form {
  display: flex;
  flex-direction: column;
  gap: var(--sp-4);
}

.user {
  margin: 0;
  font-weight: 600;
  font-size: var(--fs-md);
}

.hint {
  margin: 0;
  color: var(--text-3);
  font-size: var(--fs-sm);
}

.field {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: var(--sp-5);
}

.num {
  width: 110px;
}

.error {
  margin: 0;
  color: var(--error);
  font-size: var(--fs-sm);
}
